import { proxy } from 'valtio'
import { derive, devtools } from 'valtio/utils'
import { type RpOccurrenceStatusEnum } from '../../../../../shared/types/GlobalRPOccurrenceStatuses'
import { type RpOcurrenceTypeEnum } from '../../../../../shared/types/GlobalRPOccurrenceTypes'
import { type RecurringFrequencyType } from '../../../../../shared/types/RecurringFrequencyType'
import { type ApiCallType } from '../../../../../shared/types/ApiCallType'
import { type Pagination } from '../../../../../shared/proxies/newUserProxy'
import { DEFAULT_LIMIT } from '../../../../../shared/utils/apiUtils'
import { type GlobalCustomerType } from '../../../../../shared/types/GlobalCustomerType'
import { type Transaction } from '../../../../../shared/proxies/transactionsProxy'
import { type GlobalCustomerCardType } from '../../../../../shared/types/GlobalCustomerCardType'

export interface RpOccurrence {
  amountCents: number
  amountCurrencyType: string
  billingCycle: RecurringFrequencyType
  createdAt: Date
  customerCardId: string | null
  customerId: string
  customer: GlobalCustomerType | null
  customerCard: GlobalCustomerCardType | null
  errorCode: string | null
  errorMessage: string | null
  errorName: string | null
  id: string
  merchantId: string
  merchantAction: string | null
  paymentDate: string
  recurringPaymentId: string
  status: RpOccurrenceStatusEnum
  transactionId: string | null
  //I have no idea why that has to be specified as read-only...BC
  transactions: readonly Transaction[] | null
  type: RpOcurrenceTypeEnum
  updatedAt: Date
  userId: string | null
}

export interface GlobalRpOccurrenceType {
  allowSubmitForRetry: boolean
  apiCall: ApiCallType
  currentPage: number
  relatedApiCall: ApiCallType
  rpOccurrence: RpOccurrence | null
  relatedTransactions: Transaction[] | null
  pagination: Pagination
  displayResolveModal: boolean
  displayUpdateCardSlideOver: boolean
}

const baseProxy = proxy({
  allowSubmitForRetry: false,
  apiCall: {
    error: null,
    loading: false
  },
  currentPage: 1,
  displayResolveModal: false,
  displayUpdateCardSlideOver: false,
  pagination: {
    limit: DEFAULT_LIMIT,
    offset: 0,
    totalCount: 0
  },
  relatedApiCall: {
    error: null,
    loading: false
  },
  relatedTransactions: null,
  rpOccurrence: null

})

export const rpOccurrenceProxy = derive({}, { proxy: baseProxy }) as GlobalRpOccurrenceType

devtools(rpOccurrenceProxy, { name: 'rpOccurrenceProxy' })
